module.exports = __webpack_public_path__ + "static/media/crow.c665be62.svg";